"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyIntegerResponseSchema = exports.AppleProxyKeywordResponseSchema = exports.AppleProxyKeywordListResponseSchema = exports.AppleProxyKeywordListSchema = exports.AppleProxyKeywordUpdateBodySchema = exports.AppleProxyKeywordUpdateSchema = exports.AppleProxyCampaignRefParamsSchema = exports.AppleProxyNegativeKeywordUpdateBodySchema = exports.AppleProxyNegativeKeywordListResponseSchema = exports.AppleProxyNegativeKeywordResponseSchema = exports.AppleProxyNegativeKeywordListSchema = exports.AppleProxyNegativeKeywordSchema = exports.AppleProxyKeywordSchema = exports.AppleProxyKeywordStatusSchema = exports.AppleProxyMatchSchema = exports.AppleProxyAdGroupKeywordParamsSchema = exports.AppleProxyCampaignKeywordParamsSchema = exports.AppleProxyCampaignAdGroupParamsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const core_2 = require("./core");
const AppleProxyAdGroupRefSchema = typebox_1.Type.Integer({
    title: "Ad Group Id",
    description: "The unique identifier for the ad group.",
});
exports.AppleProxyCampaignAdGroupParamsSchema = typebox_1.Type.Object({
    adGroupId: AppleProxyAdGroupRefSchema,
    campaignId: typebox_1.Type.Integer({
        title: "Campaign Id",
        description: "The unique identifier for the campaign.",
    }),
});
exports.AppleProxyCampaignKeywordParamsSchema = typebox_1.Type.Object({
    campaignId: typebox_1.Type.Integer({
        title: "Campaign Id",
        description: "The unique identifier for the campaign.",
    }),
    keywordId: typebox_1.Type.Integer({
        title: "Keyword Id",
        description: "The unique identifier for the keyword.",
    }),
});
exports.AppleProxyAdGroupKeywordParamsSchema = typebox_1.Type.Object({
    adGroupId: typebox_1.Type.Integer({
        title: "Ad Group Id",
        description: "The unique identifier for the ad group.",
    }),
    campaignId: typebox_1.Type.Integer({
        title: "Campaign Id",
        description: "The unique identifier for the campaign.",
    }),
    keywordId: typebox_1.Type.String({
        title: "Keyword Id",
        description: "The unique identifier for the keyword.",
    }),
});
const AppleProxyBidAmountSchema = typebox_1.Type.Object(ruby_1.AppleProxyMoneySchema.properties, {
    title: "Bid Amount",
    description: "The maximum cost-per-tap/impression bid amount. This is the offer price for a keyword in a bidding auction. If the bidAmount field is null, the bidAmount uses the defaultBidAmount of the corresponding ad group.",
});
const AppleProxyDeletedSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Boolean(), {
    title: "Deleted",
    description: "The indicator of whether the keyword is soft-deleted.",
});
const AppleProxyRefSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Integer(), {
    title: "Id",
    description: "A unique identifier for the targeting keyword in the payload to update keyword bids or statuses. This keywordId is specific to a particular ad group and match type that you use to update bid amounts.",
});
exports.AppleProxyMatchSchema = (0, core_1.StringUnion)(["BROAD", "EXACT"], {
    title: "Match Schema",
    description: "An automated keyword and bidding strategy. Match type can be either Broad or Exact.",
});
exports.AppleProxyKeywordStatusSchema = (0, core_1.StringUnion)(["ACTIVE", "PAUSED"], {
    title: "Status",
    description: "The user-controlled status to enable or pause the keyword.",
});
const AppleProxyTextSchema = typebox_1.Type.String({
    title: "Text",
    description: "The word or phrase to match in App Store user searches to show your ad.",
});
exports.AppleProxyKeywordSchema = typebox_1.Type.Object({
    adGroupId: AppleProxyAdGroupRefSchema,
    bidAmount: (0, core_1.OptionalNullable)(AppleProxyBidAmountSchema),
    deleted: AppleProxyDeletedSchema,
    id: AppleProxyRefSchema,
    matchType: exports.AppleProxyMatchSchema,
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyModificationTimeSchema),
    status: (0, core_1.OptionalNullable)(exports.AppleProxyKeywordStatusSchema),
    text: AppleProxyTextSchema,
});
exports.AppleProxyNegativeKeywordSchema = typebox_1.Type.Object({
    adGroupId: (0, core_1.OptionalNullable)(AppleProxyAdGroupRefSchema),
    campaignId: (0, core_1.OptionalNullable)(typebox_1.Type.Integer(), {
        title: "Campaign Id",
        description: "The unique identifier of the campaign that the negative keywords belong to.",
    }),
    deleted: AppleProxyDeletedSchema,
    id: AppleProxyRefSchema,
    matchType: exports.AppleProxyMatchSchema,
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyModificationTimeSchema),
    status: (0, core_1.OptionalNullable)(exports.AppleProxyKeywordStatusSchema),
    text: AppleProxyTextSchema,
});
exports.AppleProxyNegativeKeywordListSchema = typebox_1.Type.Array(exports.AppleProxyNegativeKeywordSchema);
exports.AppleProxyNegativeKeywordResponseSchema = typebox_1.Type.Object({
    data: exports.AppleProxyNegativeKeywordSchema,
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyNegativeKeywordListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyNegativeKeywordListSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyNegativeKeywordUpdateBodySchema = typebox_1.Type.Array(exports.AppleProxyNegativeKeywordSchema);
exports.AppleProxyCampaignRefParamsSchema = typebox_1.Type.Object({
    campaignId: typebox_1.Type.Integer(),
}, {
    title: "Campaign Id",
    description: "The unique identifier for the campaign.",
});
exports.AppleProxyKeywordUpdateSchema = typebox_1.Type.Object({
    adGroupId: AppleProxyAdGroupRefSchema,
    bidAmount: (0, core_1.OptionalNullable)(ruby_1.AppleProxyMoneySchema, {
        title: "Bid Amount",
        description: "The maximum cost-per-tap/impression bid amount. This is the offer price for a keyword in a bidding auction. If the bidAmount field is null, the bidAmount uses the defaultBidAmount of the corresponding ad group.",
    }),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean(), {
        title: "Deleted",
        description: "An indicator of whether the keyword is soft-deleted.",
    }),
    id: AppleProxyRefSchema,
    matchType: (0, core_1.OptionalNullable)(exports.AppleProxyMatchSchema),
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyModificationTimeSchema),
    status: (0, core_1.OptionalNullable)(exports.AppleProxyKeywordStatusSchema, {
        title: "Status",
        description: "The user-controlled status to enable or pause the keyword.",
    }),
    text: typebox_1.Type.String({
        title: "Text",
        description: "The word or phrase to match in App Store user searches to show your ad.",
    }),
}, {
    title: "KeywordUpdateRequest",
    description: "Targeting keyword parameters to use in requests and responses.",
});
exports.AppleProxyKeywordUpdateBodySchema = typebox_1.Type.Array(exports.AppleProxyKeywordUpdateSchema, {
    title: "Keyword Update Request",
    description: "The request body that includes keyword targeting details.",
});
exports.AppleProxyKeywordListSchema = typebox_1.Type.Array(exports.AppleProxyKeywordSchema, {
    title: "Keyword List",
    description: "The request body that includes keyword targeting details.",
});
exports.AppleProxyKeywordListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyKeywordListSchema, {
        title: "Data",
        description: "Response data that the API provides.",
    }),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyKeywordResponseSchema = typebox_1.Type.Object({
    data: exports.AppleProxyKeywordSchema,
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyIntegerResponseSchema = typebox_1.Type.Object({
    data: typebox_1.Type.Integer(),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
